import { Model } from 'libx'
import path from 'path'
import { observable, computed, reaction } from 'mobx'
import moment from 'moment'
import uniqueId from 'lodash/uniqueId'
import { required } from 'validx'
import { editor, field } from 'data/editor'
import * as DocumentTypes from 'misc/DocumentTypes'

export default class Document extends Model {
  @observable cid = uniqueId('document-')
  @observable label = ''
  @observable type = ''
  @observable description = ''
  @observable fileName = ''
  @observable dateUpdated = moment()
  @observable uploadProgress = null
  @observable fileObject = null
  @observable year = ''
  @observable downloadLink = ''
  @observable jobId

  @observable category = 'PERSONAL'

  constructor () {
    super(...arguments)
    this.editor = new DocumentEditor(this, { rootStore: this.rootStore })
  }

  @computed get fileType () {
    if (!this.fileName) {
      return ''
    }

    return path.extname(this.fileName).substring(1)
  }

  @computed get isNew () {
    // It's a new document if there's a file object present.
    // (we remove this after uploading)
    return !!this.fileObject
  }

  @computed get friendlyType () {
    return DocumentTypes[this.category][this.type]
  }

  parse (json) {
    const meta = json.Metadata
    return {
      id: json.Key,
      fileName: path.basename(json.Key),
      dateUpdated: json.LastModified ? moment(json.LastModified) : this.dateUpdated,
      // If we are fetching the object
      // list and don't need to refresh meta..
      ...meta && {
        label: meta.name,
        description: meta.notes,
        type: meta.type || 'OTHER',
        year: meta.year,
        jobId: meta.job,
        category: meta.category || 'PERSONAL',
        // need to store uploader ID in meta
        uploadedBy: meta.uploader
          ? this.rootStore.userStore.users.set({ user_id: meta.uploader })
          : undefined
      }
    }
  }

  download () {
    return this.rootStore.documentStore.download(this)
  }
}

@editor()
export class DocumentEditor {
  @field label = ''
  @field description = ''
  @field type = ''
  @field year = ''
  @field category = 'PERSONAL'

  validationRules = {
    label: [required('File name is required')],
    type: [required('Type is required')],
    category: [required('Category is required')],
    description: [
      ({ value }) => value ? (value.length < 100 ? true : 'Description is too long') : true
    ],
    year: [required('Year is required')]
  }

  constructor (model, opts) {
    this.model = model
    this.documentStore = opts.rootStore.documentStore
    reaction(() => this.category, () => {
      if (!this.category || this.type in DocumentTypes[this.category] === false) {
        this.set({ type: '' })
      }
    })
  }

  @computed get availableDocumentTypes () {
    return DocumentTypes[this.category]
  }

  async save (mapped) {
    await this.documentStore.save(this.model, mapped)
    return true
  }

  cancelEditing () {
    if (this.model.isNew) {
      this.documentStore.removeStagedDocument(this.model)
    }
  }
}



// WEBPACK FOOTER //
// ./src/client/domain/Document.js